<template>
  <nav
    :class="`navbar ${$style.navbar}`"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand" :class="$style.navBrand">
      <router-link class="navbar-item" to="/">
        <div :class="$style.logoDivider">
          <img :src="logoMain" :class="`${$style.jbiLogo}`" />
        </div>
      </router-link>

      <router-link to="/">
        <img :src="logoApp" :class="`${$style.appLogo}`" data-test="app-logo" />
      </router-link>

      <div :class="$style.navMain">
        <slot name="main"></slot>
      </div>
    </div>
    <div id="loading-bar" :class="$style.loadingBar"></div>
  </nav>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class BaseNav extends Vue {
  @Prop({ type: String, required: true })
  public logoMain!: string;
  @Prop({ type: String, required: true })
  public logoApp!: string;
}
</script>
<style lang="scss" module>
.navbar {
  padding-left: 28px;
  padding-right: 40px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.jbiLogo {
  width: 68.57px;
  height: 22.1px;
}

.appLogo {
  height: 20px;
  margin-top: 20px;
  margin-left: 7px;
}

.logoDivider {
  border-right: 1px solid $grey-border-3;
  height: 22.1px;
  padding-right: 16px;
}

.navMain {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
}

.navBrand {
  width: 100%;
  height: 60px;
}

.loadingBar {
  &#{&} {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100vw;
    min-height: 10px;
  }
}
</style>
